import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const base = "https://www.thedesignshowroom.com";

export default function useCanonical() {
  const location = useLocation();

  useEffect(() => {
    // normalize path
    let path = location.pathname;

    // remove trailing slash (except root)
    if (path !== "/" && path.endsWith("/")) {
      path = path.slice(0, -1);
    }

    // build canonical
    const canonicalURL = base + (path === "/" ? "/" : path);

    // get or create canonical tag
    let link = document.querySelector("link[rel='canonical']");

    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }

    link.href = canonicalURL;
  }, [location.pathname]);
}